import React from 'react'
import styles from './style.module.scss'
import dynamic from 'next/dynamic'
import { Col, Row } from 'react-bootstrap'
import ArticleGrid from '@shared/components/article/articleGrid'
import useWindowSize from '@shared/hooks/windowSize'
import PropTypes from 'prop-types'
import CustomLink from '@shared/components/customLink'
import { RightArrow } from '@shared/components/ctIcons'
const TrendingNewsContent = dynamic(() => import('../olympicsTrendingNews/trendingNewsContent'))
export default function BlogsNews({ data, isHockey = false, isChampion = false, isMobile = false, isWPL = false }) {
  const [width] = useWindowSize()
  return (
    <div className={styles.leaguePointsTable}>
      <div className="widget-title d-flex justify-content-between align-items-center mt-4">
        <h3 className="small-head d-flex align-items-center my-2 fw-bold">Blogs & News</h3>
      </div>
      <div>
        {width > 991 ? (
          <>
            <Row>
              {data?.map((a, i) => {
                return (
                  <Col lg={3} sm={6} id={a?._id} key={i + a?._id}>
                    <ArticleGrid data={a} isMobile isVideo={a?.__typename === 'oVideoData'} showDuration />
                  </Col>
                )
              })}
            </Row>
            <div className="text-center w-100 mb-4">
              <CustomLink href={isChampion ? '/cricket/series/icc-champions-trophy-2025/news' : isWPL ? '/cricket/series/womens-premier-league-2025/news' : '/hockey'} prefetch={false}>
                <a className="theme-btn btn btn-primary w-100">
                  Read More
                  <RightArrow />
                </a>
              </CustomLink>
            </div>
          </>
        ) : (
          <>
            <div className="trendingList">
              <TrendingNewsContent isMobile={isMobile} data={data} imgCol={5} />
            </div>
              {!isMobile && <div className="text-center w-100 mb-4">
                <CustomLink href={isChampion ? '/cricket/series/icc-champions-trophy-2025/news' : isWPL ? '/cricket/series/womens-premier-league-2025/news' : '/hockey'} prefetch={false}>
                <a className="theme-btn btn btn-primary w-100">
                  Read More
                  <RightArrow />
                </a>
              </CustomLink>
            </div>}
          </>
        )}
      </div>
    </div>
  )
}
BlogsNews.propTypes = {
  data: PropTypes.any,
  isHockey: PropTypes.bool,
  isChampion: PropTypes.bool,
  isMobile: PropTypes.bool,
  isWPL: PropTypes.bool
}
